<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-14 18:12:46
 * @Description: tabs组件
-->
<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" class="ls-ui-tabs">
    <template v-for="item in options">
      <el-tab-pane
        :key="item.name"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </template>
  </el-tabs>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsTabs',
  componentName: 'LsTabs',
  mixins: [mixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {
    activeName: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v)
      }
    },
  },
  created() {},
  methods: {
    handleClick(tab, event) {
      this.$emit('tabClick', tab, event)
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>